import secureLocalStorage from "react-secure-storage";

export const clearStore = () => {
  Object.keys(localStorage).forEach((key) => {
    localStorage.setItem(key, "");
  });
  secureLocalStorage.clear();
};

export const setStorageItem = (key: string, d: any) => {
  const data = typeof d === "object" ? JSON.stringify(d) : d;
  secureLocalStorage.setItem(key, data);
};

export const getStorageItem = (key: string, parse = true) => {
  const data = secureLocalStorage.getItem(key);
  return parse ? (data ? JSON.parse(data as any) : null) : data;
};
